/**
 * @description 深度clone
 * @param target {array|object}
 * @returns {{}|*[]}
 */
function deepClone(target) {
  return backCloneTarget(target);
}

function backCloneTarget(target) {
  return isObject(target)
    ? cloneObject(target)
    : isArray(target)
    ? cloneArray(target)
    : target;
}
// function isFunction(target) {
//   return Object.prototype.toString.call(target) === "[object Function]";
// }
function isObject(target) {
  return Object.prototype.toString.call(target) === "[object Object]";
}
function isArray(target) {
  return Array.isArray(target);
}
function cloneArray(arr) {
  const temp = [];
  arr.forEach((ele) => {
    temp.push(backCloneTarget(ele));
  });
  return temp;
}
function cloneObject(obj) {
  const temp = {};
  Object.entries(obj).forEach(([key, value]) => {
    temp[key] = backCloneTarget(value);
  });
  Object.setPrototypeOf(temp, obj);
  return temp;
}

export default deepClone;
